import React from 'react';
import './OfferDescription.less';

export const OfferDescription = ({text}) => {
	return <span className="offer-description">{text}</span>
}
